import React from 'react';
import PropTypes from 'prop-types';
import { MSV } from '../../../../../constants/shared/TrcConstants';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const MARKS_BOUNDARIES = [5, 10, 20, 35, 50, 100];

const calculateMsvMaxMark = maxMark => MARKS_BOUNDARIES.find(mark => mark >= maxMark);

const MsvGraph = ({ msvSummary }) => {
    const { scM, scS, scV, errorM, errorS, errorV } = msvSummary;
    const msvMaxMark = calculateMsvMaxMark(Math.max(scM, scS, scV, errorM, errorS, errorV));
    return (
        <div className="chart">
            <div className="chart-diagram">
                {MSV.map(letter => {
                    const scBarHeight = msvSummary[`sc${letter}`] || 0;
                    const errorHeight = msvSummary[`error${letter}`] || 0;
                    const scBarRelativeHeight = `${(scBarHeight / msvMaxMark) * 100}%`;
                    const errorBarRelativeHeight = `${(errorHeight / msvMaxMark) * 100}%`;
                    return (
                        <div
                            key={generateReactKey(letter)}
                            className={`grade ${letter.toLowerCase()}-graph`}
                        >
                            <div
                                className="grade-border green"
                                style={{ height: scBarRelativeHeight }}
                            />
                            <div
                                className="grade-border"
                                style={{ height: errorBarRelativeHeight }}
                            />
                        </div>
                    );
                })}
                <div className="diagram-data number-five">{msvMaxMark}</div>
                <div className="diagram-data latter-m">m</div>
                <div className="diagram-data latter-s">s</div>
                <div className="diagram-data latter-v">v</div>
            </div>
        </div>
    );
};

MsvGraph.defaultProps = {
    msvSummary: {},
};

MsvGraph.propTypes = {
    msvSummary: PropTypes.object,
};

export default MsvGraph;
